import {
    createSelector,
} from 'reselect';

import {
    STATION_IS_ACTIVE_DEFAULT,
} from '../constants';
import {
    selectRawFilterData,
} from './general';

function _selectStations(state, filterId) {
    return selectRawFilterData(state, filterId).stations;
}

function _selectStationLegFilterData(stations) {
    return Object.entries(stations).reduce((map, [stationId, isActive]) => ({
        ...map,
        [stationId]: {
            isActive,
        },
    }), {});
}

function _selectStationsFilterData(stations = {}) {
    const {
        arrival = {},
        departure = {},
    } = stations;
    const arriveFilters = _selectStationLegFilterData(arrival);
    const departFilters = _selectStationLegFilterData(departure);

    return {
        arrival: arriveFilters,
        departure: departFilters,
    };
}

const selectStationsFilterData = createSelector(
    _selectStations,
    _selectStationsFilterData,
);

function _isStationLegFilterd(stationLeg) {
    return Object.values(stationLeg)
        .some((
            isActive,
        ) => isActive !== STATION_IS_ACTIVE_DEFAULT);
}
function _isStationsFiltered(stations = {}) {
    const {
        arrival = {},
        departure = {},
    } = stations;
    return {
        arrival: _isStationLegFilterd(arrival),
        departure: _isStationLegFilterd(departure),
    };
}

const selectStationsIsFiltered = createSelector(
    _selectStations,
    _isStationsFiltered,
);

export {
    selectStationsFilterData,
    selectStationsIsFiltered,
};
